import {useIsAuthenticatedValue} from '@/auth/hooks/useIsAuthenticated'
import {getCartQueryOptions} from '@/lib/cart/hooks/useCart'
import {useLocale} from '@/lib/locale/locale'
import type {Cart} from '@/models/cartModel'

const selectWalletData = (data: Cart) => {
  return data.wallet
}

export function useWallet() {
  const [locale] = useLocale()
  const isAuthenticated = useIsAuthenticatedValue()

  const {data: cartData} = useQuery(
    getCartQueryOptions({locale, isAuthenticated}, {select: selectWalletData}),
  )

  return {
    data: cartData,
  }
}
